// extracted by mini-css-extract-plugin
export default {"textRow":"xNCOBx5V43k_Qv_r9Wrs"};